import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  UPLOAD_BATCH_CLAIM_TEST_FILE_REQUEST: '',
  UPLOAD_BATCH_CLAIM_TEST_FILE_SUCCESS: '',
  UPLOAD_BATCH_CLAIM_TEST_FILE_FAILURE: '',

  UPLOAD_BATCH_CLAIM_FILES_REQUEST: '',
  UPLOAD_BATCH_CLAIM_FILES_SUCCESS: '',
  UPLOAD_BATCH_CLAIM_FILES_FAILURE: '',

  GET_SUBMITTED_BATCH_REPORTS_REQUEST: '',
  GET_SUBMITTED_BATCH_REPORTS_SUCCESS: '',
  GET_SUBMITTED_BATCH_REPORTS_FAILURE: '',

  GET_CLAIM_BATCH_TEST_HISTORY_REQUEST: '',
  GET_CLAIM_BATCH_TEST_HISTORY_SUCCESS: '',
  GET_CLAIM_BATCH_TEST_HISTORY_FAILURE: '',

  GET_ALL_CLAIM_BATCH_TEST_HISTORY_REQUEST: '',
  GET_ALL_CLAIM_BATCH_TEST_HISTORY_SUCCESS: '',
  GET_ALL_CLAIM_BATCH_TEST_HISTORY_FAILURE: '',

  INSERT_CLAIM_BATCH_HEADER_REQUEST: '',
  INSERT_CLAIM_BATCH_HEADER_SUCCESS: '',
  INSERT_CLAIM_BATCH_HEADER_FAILURE: '',
};

types = setStoreTypeValues(types, 'claimBatchReports');

export default types;
